<template>
  <div>
    <Header />
    <AppMain />
    <Footer />
  </div>
</template>

<script>
import Header from "./components/header.vue";
import AppMain from "./components/appMain.vue";
import Footer from "./components/footer.vue";
export default {
  name: "Home",
  components: {
    Header,
    AppMain,
    Footer,
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
    };
  },
};
</script>

<style scoped>
</style>
